import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Editor } from 'primereact/components/editor/Editor'

const HtmlEditor = ({
  value,
  height = 500,
  onTextChange,
  placeholder,
  completeHeader,
  disabled,
}) => {
  const headerTemplate = (
    <div className='formats-container'>
      <span className='ql-formats fix-scale'>
        <select className='ql-header' defaultValue=''>
          <option value='1'>Heading</option>
          <option value='2'>Subheading</option>
          <option value=''>Normal</option>
        </select>
        <select className='ql-font' defaultValue=''>
          <option value=''>Sans Serif</option>
          <option value='serif'>Serif</option>
          <option value='monospace'>Monospace</option>
        </select>
      </span>
      <span className='ql-formats fix-scale'>
        <button className='ql-bold' aria-label='Bold' type='button' />
        <button className='ql-italic' aria-label='Italic' type='button' />
        <button className='ql-underline' aria-label='Underline' type='button' />
      </span>
      <span className='ql-formats fix-scale'>
        <button
          className='ql-list'
          value='ordered'
          aria-label='Ordered List'
          type='button'
        />
        <button
          className='ql-list'
          value='bullet'
          aria-label='Unordered List'
          type='button'
        />
        <select className='ql-align' defaultValue=''>
          <option value='' />
          <option value='center' />
          <option value='right' />
          <option value='justify' />
        </select>
      </span>
    </div>
  )

  return (
    <Fragment>
      <Editor
        className='notes-editor-container'
        placeholder={placeholder}
        style={{ height }}
        value={value}
        headerTemplate={!completeHeader && headerTemplate}
        onTextChange={onTextChange}
        readonly={disabled}
      />
    </Fragment>
  )
}

HtmlEditor.propTypes = {
  value: PropTypes.string,
  height: PropTypes.number,
  onTextChange: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  completeHeader: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default HtmlEditor
